import css from 'styled-jsx/css';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Card from '../common/layout/Card';
import Form from '../common/forms/Form';
import Button from '../common/elements/Button';
import FormControl from '../common/elements/FormControl';
import { validate, strings } from '../common/forms/Validations';
import CountrySelector from '../common/elements/CountrySelector';
import DateControl from '../common/forms/DateControl';
import { dimensions } from '../common/Theme';

const styles = css`
  .user-profile-form {
    display: flex;
    flex-direction: column;
    padding: 12px;
  }
  .action-buttons {
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 680px) {
    .action-buttons {
      flex-direction: row-reverse;
      justify-content: space-between;
    }
  }
`;

const buttonStyles = css.resolve`
  @media (min-width: 680px) {
    .modify-button,
    .cancel-button {
      padding: 18px 12px;
      min-width: 170px;
    }
  }
`;

const countryStyles = css.resolve`
  .country {
    margin-bottom: ${dimensions.ywgFormSpacing};
  }
`;

const formStyles = css.resolve`
  .user-profile-form {
    border-radius: 16px;
  }
`;

const validators = () => {
  return {
    id: [strings.required],
    firstname: [],
    lastname: [],
    email: [strings.required],
    address: [],
    birthday: [],
    city: [],
    country: [],
    phone: [],
    postalcode: []
  };
};
const emptyProfile = {
  firstname: '',
  lastname: '',
  address: '',
  birthday: '',
  city: '',
  country: '',
  phone: '',
  postalcode: ''
};
const UserProfileFrom = ({ profile, countries, saveUser, cancelEdit }) => {
  return (
    <>
      <Card
        className={classnames('user-profile-form', formStyles.className)}
        onKeyUp={evt => {
          console.log(evt);
          evt.keyCode == 27 ? cancelEdit() : null;
        }}
      >
        <Form
          initialValues={{ ...emptyProfile, ...profile }}
          validate={value => validate(value, validators())}
          onSubmit={saveUser}
        >
          {({
            values,
            metas,
            onChange,
            onBlur,
            doSubmit,
            submitting,
            ...form
          }) => (
            <form className="user-profile-form" onSubmit={doSubmit}>
              <FormControl
                name="firstname"
                label="PRÉNOM"
                autoComplete="given-name"
                type="text"
                value={values.firstname}
                onChange={onChange}
                onBlur={onBlur}
                valid={metas.firstname.valid}
                autoFocus
              />
              <FormControl
                name="lastname"
                autoComplete="family-name"
                label="NOM DE FAMILLE"
                type="text"
                value={values.lastname}
                onChange={onChange}
                onBlur={onBlur}
                error={metas.lastname.error}
                valid={metas.lastname.valid}
              />
              <DateControl
                label="DATE DE NAISSANCE"
                name="birthday"
                value={values.birthday}
                onChange={onChange}
                onBlur={onBlur}
                error={metas.birthday}
                valid={metas.birthday.valid}
              />
              <FormControl
                name="email"
                autoComplete="email"
                label="EMAIL"
                type="mail"
                value={values.email}
                required
                onChange={onChange}
                onBlur={onBlur}
                error={metas.email.error}
                valid={metas.email.valid}
              />
              <FormControl
                type="text"
                label="ADRESSE"
                name="address"
                autoComplete="address-line1"
                value={values.address}
                onChange={onChange}
                onBlur={onBlur}
                error={metas.address.error}
                valid={metas.address.valid}
                tabIndex="0"
              />
              <FormControl
                label="CODE POSTAL"
                type="number"
                name="postalcode"
                autoComplete="postal-code"
                value={values.postalcode}
                error={metas.postalcode.error}
                valid={metas.postalcode.valid}
                onChange={onChange}
                onBlur={onBlur}
                tabIndex="0"
              />
              <FormControl
                label="VILLE"
                type="text"
                name="city"
                autoComplete="address-level2"
                value={values.city}
                onChange={onChange}
                onBlur={onBlur}
                error={metas.city.error}
                valid={metas.city.valid}
                tabIndex="0"
              />
              <FormControl
                label="TÉLÉPHONE DE CONTACT"
                type="tel"
                name="phone"
                autoComplete="phone"
                value={values.phone}
                onChange={onChange}
                onBlur={onBlur}
                error={metas.phone.error}
                valid={metas.phone.valid}
                tabIndex="0"
              />
              <CountrySelector
                label="PAYS DE RÉSIDENCE"
                name="country"
                className={classnames(
                  'country',
                  'form-control',
                  countryStyles.className
                )}
                countries={countries}
                value={values.country}
                valid={metas.country.valid}
                error={metas.country.error}
                onChange={onChange}
                onBlur={onBlur}
              />
              <div className="action-buttons">
                <Button
                  type="submit"
                  submitting={submitting}
                  className={classnames(
                    'modify-button',
                    buttonStyles.className
                  )}
                >
                  Modifier
                </Button>
                <Button
                  type="button"
                  secondary
                  onClick={cancelEdit}
                  className={classnames(
                    'cancel-button',
                    buttonStyles.className
                  )}
                >
                  Annuler
                </Button>
              </div>
            </form>
          )}
        </Form>
      </Card>
      <style jsx>{styles}</style>
      {buttonStyles.styles}
      {countryStyles.styles}
      {formStyles.styles}
    </>
  );
};

UserProfileFrom.propTypes = {
  profile: PropTypes.object.isRequired
};

export default UserProfileFrom;
